<template>
  <div class="w-100">
    <b-nav class="w-100" align="center">
      <b-nav-item class="mynavbtn" :to="{name:'proOverview'}">
        商品總覽
      </b-nav-item>
      <b-nav-item class="mynavbtn" :to="{name:'proBaseField'}">
        批次編輯商品
      </b-nav-item>
      <b-nav-item class="mynavbtn" :to="{name:'proUploadImg'}">
        批次傳圖
      </b-nav-item>
      <b-nav-item class="mynavbtn" :to="{name:'proClassify'}">
        批次歸類
      </b-nav-item>
      <b-nav-item class="mynavbtn" :to="{name:'proSortClass'}">
        商品分類
      </b-nav-item>
    </b-nav>

    <router-view></router-view>
  </div>
</template>

<script>
  import productManagement from "@/js/productManagement";
  export default productManagement;

</script>
